import apiServices from 'config/apiServiceApiGateway'
import type {
  GetManualAssignmentsResponseType,
  GetUserExperimentListParamsType,
  GetUserExperimentListResponseType,
  PatchManualAssignmentsPayloadType,
} from 'features/ABAdmin/@types/UserList'

const { Get, Patch } = apiServices

export const getUserExperimentList = (params: GetUserExperimentListParamsType) =>
  Get<GetUserExperimentListResponseType>({
    url: '/abtesting/internal/:version/experiment/user/search',
    version: 'v1',
    params,
  })

export const getManualAssignments = (experimentId: number) =>
  Get<GetManualAssignmentsResponseType>({
    url: '/abtesting/internal/:version/experiment/:experimentId/user/manual-assignments',
    version: 'v1',
    urlParams: { experimentId },
  })

export const patchManualAssignments = ({
  experimentId,
  users,
}: PatchManualAssignmentsPayloadType) =>
  Patch({
    url: '/abtesting/internal/:version/experiment/:experimentId/manual-assignments',
    version: 'v1',
    urlParams: { experimentId },
    data: { users },
  })
